// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--2GkWA","logo":"Header-module--logo--u7kuI","wrapper":"Header-module--wrapper--3DRDl"};